import { useEffect, useRef } from 'react'

export function useScrollAnimation() {
  const ref = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const el = ref.current
    if (!el) return

    const observer = new IntersectionObserver(
      (entries) => {
        for (let i = 0; i < entries.length; i++) {
          if (entries[i].isIntersecting) {
            const target = entries[i].target as HTMLElement
            target.classList.replace('scroll-hidden', 'scroll-visible')
            observer.unobserve(target)
          }
        }
      },
      { threshold: 0.1, rootMargin: '100px 0px' },
    )

    const children = el.getElementsByClassName('scroll-hidden')
    for (let i = 0; i < children.length; i++) {
      observer.observe(children[i])
    }

    return () => observer.disconnect()
  }, [])

  return ref
}
